export const iconFontAwesomeCampingMap = (
	<i className="fa-solid fa-map"></i>
);
